import { motion } from "framer-motion";
import { fadeUp, inViewOnce } from "@/lib/motion";
import { track } from "@/lib/track";
import { EVENTBRITE_URL } from "@/lib/data";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-28 md:py-48 bg-[color:var(--ink)] text-[color:var(--bone)] overflow-hidden"
    >
      {/* Ambient copper glow */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(60% 50% at 50% 100%, rgba(126, 217, 87, 0.28), transparent 70%)",
        }}
      />

      <div className="relative mx-auto max-w-[1360px] px-5 md:px-8">
        <div className="flex items-center justify-between mb-14 md:mb-20">
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[color:var(--copper)]">
            Ch. 08 — Enroll
          </span>
          <span className="font-mono text-[11px] tabular-nums text-[color:var(--bone)]/50">
            §008 / 010
          </span>
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={inViewOnce}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.1 } },
          }}
          className="max-w-[1100px]"
        >
          <motion.h2
            variants={fadeUp}
            className="font-serif text-[46px] sm:text-[72px] md:text-[104px] lg:text-[120px] leading-[0.95] tracking-[-0.04em] font-medium text-balance"
          >
            Build the skills to{" "}
            <em className="italic font-normal text-[color:var(--copper)]">
              engineer
            </em>{" "}
            finance AI — not just use it.
          </motion.h2>

          <motion.p
            variants={fadeUp}
            className="mt-8 max-w-[640px] text-[16px] md:text-[18px] leading-[1.6] text-[color:var(--bone)]/80"
          >
            Join Nicole for a live certification focused on building, evaluating
            and controlling agentic AI workflows for finance.
          </motion.p>

          <motion.div
            variants={fadeUp}
            className="mt-10 flex flex-wrap items-center gap-3"
          >
            <a
              href="#pricing"
              data-testid="final-cta-primary"
              onClick={() => track("final_cta_click", { cta: "choose_pass" })}
              className="inline-flex items-center gap-2 bg-[color:var(--copper)] text-[color:var(--ink)] px-6 py-4 rounded-full font-medium text-[15px] hover:bg-[color:var(--bone)] transition-colors"
            >
              Choose Your Pass
              <span>→</span>
            </a>
            <a
              href={EVENTBRITE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-secondary"
              onClick={() => track("final_cta_click", { cta: "eventbrite" })}
              className="inline-flex items-center gap-2 border border-[color:var(--bone)]/30 text-[color:var(--bone)] px-6 py-4 rounded-full font-medium text-[15px] hover:bg-[color:var(--bone)] hover:text-[color:var(--ink)] transition-colors"
            >
              View on Eventbrite
            </a>
          </motion.div>

          <motion.p
            variants={fadeUp}
            className="mt-8 font-mono text-[11px] uppercase tracking-[0.24em] text-[color:var(--copper)]"
          >
            VIP access is limited to 10 participants.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
}
